import Vue from 'vue'

Vue.component('scraper-input-builder-array', () => import('./Array.vue'))
Vue.component('scraper-input-builder-string', () => import('./String.vue'))